export default __webpack_public_path__ + "static/media/chuty.7ed35d25.png";